module.exports = __webpack_public_path__ + "img/downlight.b8517701.jpg";